import Request from '../modules/XMLHttpRequest';

class Checkout {

    constructor() {
        this.checkoutPage = document.querySelector('[data-js="checkout-page"]');

        if (this.checkoutPage) {
            this.paymentMethod = this.checkoutPage.querySelector('[data-js="payment-method"]');
            this.language = document.getElementsByTagName('html')[0].getAttribute('commerce-lang');
            this.orderBtn = this.paymentMethod.querySelector('[data-js="place-order-btn"]');

            this.paymentMethodChoiceInteraction();
            //this.acceptConditionsInteraction();
            this.placeOrder();
        }
    }

    paymentMethodChoiceInteraction() {
        let paymentChoice = this.paymentMethod.querySelectorAll('[data-js="payment-choice"]');
        [...paymentChoice].forEach(paymentChoice => paymentChoice.addEventListener('change', (e) => this.paymentMethodChoice(e)));
    }

    paymentMethodChoice(e) {
        let $this = this,
            request = new Request(),
            paymentInfoCon = this.paymentMethod.querySelector('[data-js="payment-method-info"]'),
            id = e.target.getAttribute('id');

        request.get(`/api/cartapi/GetPaymentSummary/${id}/${this.language}`).then(function (response) {
            paymentInfoCon.innerHTML = JSON.parse(response).Html;
            //$this.orderBtnStatus();
        }, function (error) {
            console.error("Failed!", error);
        });
    }

    acceptConditionsInteraction() {
        let acceptConditionsInput = this.checkoutPage.querySelector('[data-js="accept-conditions"]');
        acceptConditionsInput.addEventListener('change', (e) => this.orderBtnStatus());
    }

    orderBtnStatus(obj) {
        let radioBtn = this.paymentMethod.querySelectorAll('[data-js="payment-choice"]:checked'),
            checkbox = this.paymentMethod.querySelectorAll('[data-js="accept-conditions"]:checked');

        if (radioBtn.length && checkbox.length) {
            $(this.orderBtn).removeClass('disabled');
        } else {
            this.orderBtn.className += ' disabled';
        }
    }

    placeOrder() {
        let form = this.checkoutPage.querySelector('[data-js="checkout-page-form"]');

        form.addEventListener('submit', function (event) {
            if (form.checkValidity() === false) {
                event.preventDefault();
                event.stopPropagation();

                let $errorObj = $('.form-control:invalid').first();

                if($errorObj.length) {
                    if (!$errorObj.is(':visible')) {
                        $errorObj.parents('[data-js="toggle-box-target"]:first').siblings('[data-js="toggle-box-trigger"]').trigger('click');
                    }

                    $('html, body').animate({ scrollTop: $errorObj.offset().top - 100 }, 500);
                }
            }
            form.classList.add('was-validated');
        }, false);
    }
}

export default Checkout;